<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container">
          <div class="grid justify-content-between">
            <div class="col-12 md:col-6 lg:col-5">
              <div class="">
                <div class="flex align-items-center">
                  <div class="ml-2">
                    <div class="text-2xl text-primary font-bold">
                      {{ $t("applicants_details") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container">
        <div class="grid">
          <div class="col comp-grid">
            <div class="">
              <div>
                <div class="relative-position" style="min-height: 100px">
                  <template v-if="!loading && item">
                    <div class="row q-col-gutter-x-md">
                      <div class="col-12">
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("first_institution_first_programme_id") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.first_institution_first_programme_id }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("first_institution_second_programme_id") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.first_institution_second_programme_id }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("first_institution_third_programme_id") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.first_institution_third_programme_id }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("institution_additional_info") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.institution_additional_info }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("date_created") }}:
                            </div>
                            <div class="font-bold">
                              <Chip
                                v-if="item.date_created"
                                :label="$utils.relativeDate(item.date_created)"
                                v-tooltip="{
                                  value: $utils.humanDatetime(
                                    item.date_created
                                  ),
                                }"
                              />
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("shs_exams_results") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.shs_exams_results }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("has_attended_tertiary") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.has_attended_tertiary }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("attended_shs") }}:
                            </div>
                            <div class="font-bold">{{ item.attended_shs }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("same_bio_as_sponsor") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.same_bio_as_sponsor }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("second_institution_first_programme_id") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.second_institution_first_programme_id }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t("second_institution_second_programme_id")
                              }}:
                            </div>
                            <div class="font-bold">
                              {{ item.second_institution_second_programme_id }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("second_institution_third_programme_id") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.second_institution_third_programme_id }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("is_athlete") }}:
                            </div>
                            <div class="font-bold">{{ item.is_athlete }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("allow_two_factor_auth") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.allow_two_factor_auth }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("allow_email_alert") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.allow_email_alert }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("allow_sms_alert") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.allow_sms_alert }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("is_fee_paying") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.is_fee_paying }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("email_verified_at") }}:
                            </div>
                            <div class="font-bold">
                              <Chip
                                v-if="item.email_verified_at"
                                :label="
                                  $utils.relativeDate(item.email_verified_at)
                                "
                                v-tooltip="{
                                  value: $utils.humanDatetime(
                                    item.email_verified_at
                                  ),
                                }"
                              />
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("third_institution_first_programme_id") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.third_institution_first_programme_id }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("third_institution_second_programme_id") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.third_institution_second_programme_id }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("third_institution_third_programme_id") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.third_institution_third_programme_id }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("sports_rep_institution") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.sports_rep_institution }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("is_disable") }}:
                            </div>
                            <div class="font-bold">{{ item.is_disable }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("is_awaiting_results") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.is_awaiting_results }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("pass_to_affiliate") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.pass_to_affiliate }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("exams_sittings") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.exams_sittings }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("is_employed") }}:
                            </div>
                            <div class="font-bold">{{ item.is_employed }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("date_updated") }}:
                            </div>
                            <div class="font-bold">
                              <Chip
                                v-if="item.date_updated"
                                :label="$utils.relativeDate(item.date_updated)"
                                v-tooltip="{
                                  value: $utils.humanDatetime(
                                    item.date_updated
                                  ),
                                }"
                              />
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("same_address_as_ph_address") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.same_address_as_ph_address }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("first_institution_id") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.first_institution_id }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("second_institution_id") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.second_institution_id }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("third_institution_id") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.third_institution_id }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("applicant_id") }}:
                            </div>
                            <div class="font-bold">{{ item.applicant_id }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("guardian_address2") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.guardian_address2 }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("guardian_address3") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.guardian_address3 }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("guardian_occupation") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.guardian_occupation }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("guardian_telephone") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.guardian_telephone }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("passport_picture") }}:
                            </div>
                            <div class="font-bold">
                              <image-viewer
                                image-size="large"
                                image-preview-size=""
                                :src="item.passport_picture"
                                width="400px"
                                height="400px"
                                :num-display="1"
                              >
                              </image-viewer>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("last_competition") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.last_competition }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("disability") }}:
                            </div>
                            <div class="font-bold">{{ item.disability }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("employment_nature") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.employment_nature }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("employment_address") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.employment_address }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("employment_nature_other") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.employment_nature_other }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("guardian_occupation_other") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.guardian_occupation_other }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("disability_other") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.disability_other }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("religious_denomination_other") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.religious_denomination_other }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("scanned_national_id_card") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.scanned_national_id_card }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("national_id_type") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.national_id_type }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("national_id_number") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.national_id_number }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("fathers_name") }}:
                            </div>
                            <div class="font-bold">{{ item.fathers_name }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("fathers_telephone") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.fathers_telephone }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("fathers_occupation") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.fathers_occupation }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("fathers_occupation_other") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.fathers_occupation_other }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("mothers_name") }}:
                            </div>
                            <div class="font-bold">{{ item.mothers_name }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("mothers_telephone") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.mothers_telephone }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("mothers_occupation") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.mothers_occupation }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("mothers_occupation_other") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.mothers_occupation_other }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("last_shs_attended") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.last_shs_attended }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("index_number") }}:
                            </div>
                            <div class="font-bold">{{ item.index_number }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("shs_course") }}:
                            </div>
                            <div class="font-bold">{{ item.shs_course }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("shs_grade") }}:
                            </div>
                            <div class="font-bold">{{ item.shs_grade }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("certificate_url") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.certificate_url }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("shs_from_year") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.shs_from_year }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("shs_to_year") }}:
                            </div>
                            <div class="font-bold">{{ item.shs_to_year }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("shs_qualification") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.shs_qualification }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("last_tertiary_attended") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.last_tertiary_attended }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("tertiary_from_year") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.tertiary_from_year }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("tertiary_to_year") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.tertiary_to_year }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("tertiary_programme") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.tertiary_programme }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("tertiary_student_id") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.tertiary_student_id }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("tertiary_reason_for_leaving") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.tertiary_reason_for_leaving }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("tertiary_degree_awarded") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.tertiary_degree_awarded }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("tertiary_degree_class") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.tertiary_degree_class }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("last_shs_other") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.last_shs_other }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("last_shs_outside") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.last_shs_outside }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("account_name") }}:
                            </div>
                            <div class="font-bold">{{ item.account_name }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("account_username") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.account_username }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("account_email") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.account_email }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("account_status") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.account_status }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("fathers_email") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.fathers_email }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("mothers_email") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.mothers_email }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("fathers_living_status") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.fathers_living_status }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("mothers_living_status") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.mothers_living_status }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("entry_level") }}:
                            </div>
                            <div class="font-bold">{{ item.entry_level }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("entry_level_scenario") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.entry_level_scenario }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t("first_institution_first_programme_session")
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.first_institution_first_programme_session
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "first_institution_second_programme_session"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.first_institution_second_programme_session
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t("first_institution_third_programme_session")
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.first_institution_third_programme_session
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t("first_institution_first_programme_options")
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.first_institution_first_programme_options
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "first_institution_second_programme_options"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.first_institution_second_programme_options
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t("first_institution_third_programme_options")
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.first_institution_third_programme_options
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "second_institution_first_programme_session"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.second_institution_first_programme_session
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "second_institution_second_programme_session"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.second_institution_second_programme_session
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "second_institution_third_programme_session"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.second_institution_third_programme_session
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "second_institution_first_programme_options"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.second_institution_first_programme_options
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "second_institution_second_programme_options"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.second_institution_second_programme_options
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "second_institution_third_programme_options"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.second_institution_third_programme_options
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t("third_institution_first_programme_session")
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.third_institution_first_programme_session
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "third_institution_second_programme_session"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.third_institution_second_programme_session
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t("third_institution_third_programme_session")
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.third_institution_third_programme_session
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t("third_institution_first_programme_options")
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.third_institution_first_programme_options
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "third_institution_second_programme_options"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.third_institution_second_programme_options
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t("third_institution_third_programme_options")
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.third_institution_third_programme_options
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("application_ref") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.application_ref }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("application_status") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.application_status }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("payment_status") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.payment_status }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("title") }}:
                            </div>
                            <div class="font-bold">{{ item.title }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("firstname") }}:
                            </div>
                            <div class="font-bold">{{ item.firstname }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("lastname") }}:
                            </div>
                            <div class="font-bold">{{ item.lastname }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("othernames") }}:
                            </div>
                            <div class="font-bold">{{ item.othernames }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("hometown") }}:
                            </div>
                            <div class="font-bold">{{ item.hometown }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("hometown_region") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.hometown_region }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("country") }}:
                            </div>
                            <div class="font-bold">{{ item.country }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("dial_code") }}:
                            </div>
                            <div class="font-bold">{{ item.dial_code }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("primary_telephone") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.primary_telephone }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("gender") }}:
                            </div>
                            <div class="font-bold">{{ item.gender }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("religious_denomination") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.religious_denomination }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("marital_status") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.marital_status }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("dob_day") }}:
                            </div>
                            <div class="font-bold">{{ item.dob_day }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("dob_month") }}:
                            </div>
                            <div class="font-bold">{{ item.dob_month }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("dob_year") }}:
                            </div>
                            <div class="font-bold">{{ item.dob_year }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("email_address") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.email_address }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("address_line1") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.address_line1 }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("address_line2") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.address_line2 }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("address_line3") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.address_line3 }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("address_line4") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.address_line4 }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("street_address") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.street_address }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("digital_address") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.digital_address }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("ph_address_line1") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.ph_address_line1 }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("ph_address_line2") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.ph_address_line2 }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("ph_address_line3") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.ph_address_line3 }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("ph_address_line4") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.ph_address_line4 }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("sponsor_name") }}:
                            </div>
                            <div class="font-bold">{{ item.sponsor_name }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("sponsor_address") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.sponsor_address }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("sponsor_telephone") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.sponsor_telephone }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("sponsor_email") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.sponsor_email }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("guardian_name") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.guardian_name }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("guardian_email") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.guardian_email }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("guardian_address1") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.guardian_address1 }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("applicant_accepted_programme_id") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.applicant_accepted_programme_id }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "first_institution_first_programme_admission_status"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.first_institution_first_programme_admission_status
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "first_institution_second_programme_admission_status"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.first_institution_second_programme_admission_status
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "first_institution_third_programme_admission_status"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.first_institution_third_programme_admission_status
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "second_institution_first_programme_admission_status"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.second_institution_first_programme_admission_status
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "second_institution_second_programme_admission_status"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.second_institution_second_programme_admission_status
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "second_institution_third_programme_admission_status"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.second_institution_third_programme_admission_status
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "third_institution_first_programme_admission_status"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.third_institution_first_programme_admission_status
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "third_institution_second_programme_admission_status"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.third_institution_second_programme_admission_status
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{
                                $t(
                                  "third_institution_third_programme_admission_status"
                                )
                              }}:
                            </div>
                            <div class="font-bold">
                              {{
                                item.third_institution_third_programme_admission_status
                              }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="flex justify-content-end">
                          <SplitButton
                            class="p-button"
                            :model="getActionMenuModel(item)"
                          >
                            <i></i>
                          </SplitButton>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="loading">
                    <div class="p-3 text-center">
                      <ProgressSpinner style="width: 50px; height: 50px" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { defineAsyncComponent, ref } from "vue";
import { PageMixin } from "../../mixins/page.js";
import { ViewPageMixin } from "../../mixins/viewpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
import { i18n } from "../../services/i18n.js";
export default {
  name: "viewApplicantsPage",
  components: {},
  mixins: [PageMixin, ViewPageMixin],
  props: {
    pageName: {
      type: String,
      default: "applicants",
    },
    idName: {
      type: String,
      default: "applicant_id",
    },
    routeName: {
      type: String,
      default: "applicantsview",
    },
    pagePath: {
      type: String,
      default: "applicants/view",
    },
    apiPath: {
      type: String,
      default: "applicants/view",
    },
  },
  data() {
    return {
      item: {
        default: {},
      },
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return this.$t("applicants_details");
      },
    },
    currentRecord: {
      get: function () {
        return this.$store.getters["applicants/currentRecord"];
      },
      set: function (value) {
        this.$store.commit("applicants/setCurrentRecord", value);
      },
    },
  },
  meta() {
    return {
      title: this.pageTitle,
    };
  },
  methods: {
    ...mapActions("applicants", ["fetchRecord", "deleteRecord"]),
    getActionMenuModel(data) {
      return [
        {
          label: () => i18n.t("edit"),
          to: `/applicants/edit/${data.applicant_id}`,
          icon: "pi pi-pencil",
        },
      ];
    },
  },
  watch: {
    $route(to, from) {
      //only fetch data when navigated to this page
      if (to.name == this.routeName) {
        //this.load();
      }
    },
  },
  async mounted() {},
  async created() {},
};
</script>
<style scoped></style>
